export enum SubscriptionStatus
{
    ACTIVE = "active",
    PAST_DUE = "past_due",
    UNPAID = "unpaid",
    CANCELED = "canceled",
    CANCEL_PROCESSING = "cancel-processing",
    TERMINATED = "terminated",
    TRIAL = "trialing",
    TRIAL_PERIOD_ENDED = "trial-ended"
};


// WEBPACK FOOTER //
// ./src/app/shared/models/subscription-status.ts